import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon, ZapIcon } from 'lucide-react';
import { OFFER_ANCHOR, purchaseAlerts } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const MINUTES_AGO = [2, 3, 4, 6, 7, 9, 11, 13];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const showNext = () => {
      setVisible(true);
      timeout = setTimeout(() => {
        setVisible(false);
        timeout = setTimeout(() => {
          setIndex(prev => (prev + 1) % purchaseAlerts.length);
          showNext();
        }, 6000);
      }, 6000);
    };
    timeout = setTimeout(showNext, 4000);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const alert = purchaseAlerts[index];
  const minutes = MINUTES_AGO[index % MINUTES_AGO.length];
  return <AnimatePresence data-id="element-136" data-mp="164ej8hc45uny">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: EASE
    }} role="status" aria-live="polite" className="fixed bottom-3 left-3 z-50 w-[min(19rem,calc(100vw-1.5rem))]" data-id="element-137" data-mp="117frg5fx9zsx">
          <div className="relative flex items-start gap-2.5 rounded-xl border-2 border-volt bg-carbon p-2.5 pr-7 shadow-[0_10px_30px_rgba(0,0,0,0.5)]" data-id="element-138" data-mp="i81sta7900w3">
            <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-volt" data-id="element-139" data-mp="x62ivnlg3iib">
              <ZapIcon size={18} className="text-carbon" strokeWidth={2.5} data-id="element-140" data-mp="s4myzyv07i1i" />
            </span>
            <div className="min-w-0" data-id="element-141" data-mp="28j53quukuu8a">
              <p className="text-[0.78rem] font-extrabold leading-tight text-white" data-id="element-142" data-mp="28mandukft3wm">
                {alert.name}
              </p>
              <p className="text-[0.68rem] leading-tight text-steel" data-id="element-143" data-mp="2apcqgwmfcvgc">
                {alert.city}, {alert.country}
              </p>
              <a href={OFFER_ANCHOR} className="mt-0.5 block text-[0.7rem] font-bold uppercase leading-tight text-volt underline underline-offset-2" data-id="element-144" data-mp="2fm36jjy8br1r">
                Acabó de comprar este libro digital
              </a>
              <p className="text-[0.62rem] uppercase tracking-wide text-steel-dark" data-id="element-145" data-mp="1ryv2f5cjeo1b">
                Hace {minutes} minutos
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-1.5 top-1.5 text-steel transition-colors duration-150 ease-soft hover:text-white" data-id="element-146" data-mp="1wuttx1t5wm5y">
              <XIcon size={14} data-id="element-147" data-mp="197c1d422pk1x" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}